import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { useLocation } from 'react-router'
import { DetailCard } from '@tecuity/granite-ui/DetailCard'
import { Detail } from '@tecuity/granite-ui/Detail'
import { ContextBar } from '@tecuity/granite-ui/ContextBar'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import LeftArrowIcon from '@tecuity/sos-icons/react/left-arrow'
// import DollarIcon from '@tecuity/sos-icons/react/dollar-sign-double'
// import CheckboxIcon from '@tecuity/sos-icons/react/checkbox'
import { getUccInfoRequestData /*SetUccInfoRequestAsFulfilled*/ } from '../RecordDetailsActions'
import '../UCC/UccRecordDetails.scss'
import format from 'date-fns/format'
import { Spinner } from 'components/Loaders/Loaders'
import { GraniteDataGrid } from '@tecuity/granite-ui'
import { CLEAR_UCC_INFO_REQUEST } from '../RecordDetailsReducer'
import GenericDetails from '../GenericDetails'
import * as api from '../../../requests'

const UCCInfoRequestRecordDetails = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation()
  const isSidebarCollapsed = useSelector((state) => state.app.sidebarCollapsed)
  const { recordDetails } = useSelector((state) => state.record, shallowEqual)
  const [config, setConfig] = useState({})

  const docNum = useMemo(() => {
    const parts = location.pathname.split('/')
    return parts[parts.length - 1]
  }, [location])

  const DownloadZipFile = () => {
    api.GET_INFO_REQUEST_DETAIL_ZIP(docNum, (res) => {
      res.text().then((url) => {
        window.open(url, '_self')
      })
    })
  }

  useEffect(() => {
    api.GET_UCC_FILING_INFO_REQUESET_DETAIL_SETTINGS(
      (res) => {
        setConfig(res)
      },
      (err) => {
        console.error(err)
      }
    )
  }, [])

  useEffect(() => {
    dispatch(getUccInfoRequestData(docNum))
    return () => {
      dispatch({ type: CLEAR_UCC_INFO_REQUEST })
    }
  }, [docNum])

  if (!recordDetails.Id) {
    return (
      <div style={{ height: '100%', width: '100%', textAlign: 'center', padding: '4rem' }}>
        <Spinner className="page-loader" themeColor="dark-neutral" />
      </div>
    )
  }

  return (
    <div className="record">
      <div className="row header-row">
        <h1>{config.Title}</h1>
      </div>
      <GenericDetails record={recordDetails} config={config} />
      <FilingsSection docNum={docNum} />
      <VoidInfoSection />
      <div style={{ height: '75px' }}></div>
      <div className={`context-bar-wrapper ${isSidebarCollapsed ? 'sidebar-collapsed ' : ' '}`}>
        <ContextBar className="granite-context-bar">
          <ContextButton
            leftIcon={
              <div className="checkmark-wrapper left">
                <LeftArrowIcon />
              </div>
            }
            className={``}
            onClick={() => (history.goBack())}
            variant="secondary"
          >
            Back
          </ContextButton>
          {recordDetails.FulfillmentStatus != 'Fulfilled' || (
            <ContextButton className={``} onClick={DownloadZipFile}>
              Download Zip
            </ContextButton>
          )}
        </ContextBar>
      </div>
    </div>
  )
}

export default UCCInfoRequestRecordDetails

const FilingsSection = ({ docNum }) => {
  const history = useHistory()
  const [sortModel, setSortModel] = useState({ field: '', sort: '' })
  const [pageSize, setPageSize] = useState(10)
  const [pageNum, setPageNum] = useState(0)
  const [rows, setRows] = useState([])
  const [rowCount, setRowCount] = useState(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    api.GET_INFO_REQUEST_FILINGS_COUNT(
      docNum,
      (res) => {
        setRowCount(res)
      },
      (err) => {
        console.error(err)
        setRowCount(0)
      }
    )
  }, [docNum])

  useEffect(() => {
    // call new endpoint to populate list.
    setLoading(true)
    api.GET_INFO_REQUEST_FILINGS_SERVER_PAGINATED(
      docNum,
      pageNum,
      pageSize,
      sortModel.field,
      sortModel.sort.toUpperCase(),
      (res) => {
        setRows(res)
        setLoading(false)
      },
      (err) => {
        console.error(err)
        setRows([])
        setLoading(false)
      }
    )
  }, [pageNum, sortModel, pageSize, docNum])

  return (
    <Detail label="Request Results">
      <GraniteDataGrid
        columns={[
          {
            field: 'FilingNum',
            flex: 1,
            headerName: 'UCC Doc #',
            disableColumnMenu: true,
          },
          {
            field: 'ReceivedDate',
            flex: 1,
            headerName: 'UCC File Date',
            disableColumnMenu: true,
          },
        ]}
        rows={rows}
        rowCount={rowCount}
        getRowId={(row) => row.FilingNum}
        rowHeight={32}
        pagination
        paginationMode="server"
        sortingMode="server"
        rowsPerPageOptions={[10, 25]}
        pageSize={pageSize}
        onPageSizeChange={setPageSize}
        page={pageNum}
        onPageChange={setPageNum}
        onRowDoubleClick={(params) => {
          history.push(`/recordDetails/UCCSearch/${params.row.FilingNum}`)
        }}
        onSortModelChange={(model) => {
          setSortModel(model[0] || { field: '', sort: '' })
        }}
        loading={loading}
      />
    </Detail>
  )
}

const VoidInfoSection = () => {
  const { recordDetails } = useSelector((state) => state.record, shallowEqual)
  const info = recordDetails.VoidDeleteInfo || {}
  return info && info.Date ? (
    <DetailCard label="Void Information">
      <div className="ucc-row">
        <Detail fontSize="small">{`Voided on ${format(
          new Date(info.Date),
          `MM/dd/yyyy hh:mm a`
        )} by ${info.PrimaryAppUserName}`}</Detail>
      </div>
      <div className="ucc-row">
        <Detail label={`Reason`} customCss={{ whiteSpace: 'pre-wrap' }}>
          {info.Reason}
        </Detail>
      </div>
    </DetailCard>
  ) : null
}
